import routerOptions0 from "/home/runner/work/wow-guide/wow-guide/frontend-wg3/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}